<script lang="ts">
	import Switch from '$lib/components/atoms/switch/Switch.svelte';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import { track } from '$lib/services/tracking/googleAnalytics';
	import * as m from '$paraglide/messages';

	interface Props {
		detailedView?: boolean;
	}

	let { detailedView = $bindable(false) }: Props = $props();

	const mapContext = getMapLayoutContext();

	function updateSwitchState() {
		detailedView = !detailedView;

		mapContext?.mapSettingsUserPreferencesLocalStorage.set(
			'showPoiMarkerWithDetails',
			detailedView,
		);

		mapContext?.poiMarkerWithDetailsEnabled.set(detailedView);

		track({
			action: 'display_prices_ratings',
			payload: {
				action: detailedView ? 'on' : 'off',
				context: 'modal',
			},
		});
	}
</script>

<Switch id="detailed-view-switch" checked={detailedView} onchange={updateSwitchState}>
	<div class="text-md">{m.poi_filters__detailed_view__label()}</div>
</Switch>
